import {
  Box,
  Typography
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import type { TFunction } from "i18next";
import { MapPinned } from "lucide-react";
import { getModalEditionChangeStyles } from "./ModalEditionChange.style";

interface EditionHeaderProps {
  editionId: number;
  code?: string;
  location?: string;
  isVirtual: boolean;
  theme: Theme;
  t: TFunction;
}

export function EditionHeader({ editionId, code, location, isVirtual, theme, t }: EditionHeaderProps) {

  const styles = getModalEditionChangeStyles(theme);

  return ( 
    <Box 
      sx={ { 
        alignItems: "center", 
        display: "flex", 
        flexWrap: "wrap", 
        marginBottom: "0.5rem" 
      } }
    >
      <Typography sx={ styles.editionHeader.text }>
        { t("edition_name") } { editionId }
      </Typography>
      { code && (
        <>
          <Typography component="span" sx={ { ...styles.editionHeader.text, mx: 0.5 } }>|</Typography>
          <Typography variant="body2" sx={ styles.editionHeader.text }>
            { t("code_field") }: { code }
          </Typography>
        </>
      ) }
      { !isVirtual && location && (
        <>
          <Typography component="span" sx={ { ...styles.editionHeader.text, mx: 0.5 } }>|</Typography>
          <MapPinned
            size={ "1rem" }
            color={ theme.customColors.exploreCardText }
            opacity={ 0.7 }
            style={ { marginRight: "0.25rem" } }
          />
          <Typography variant="body2" sx={ styles.editionHeader.text }>
            { location }
          </Typography>
        </>
      ) }
    </Box>
  );
}
